export {
	CTARow as MarketingCTARow,
	Header as MarketingHeader,
	Highlight as MarketingHighlight,
	Signup as MarketingSignup,
	Usp as MarketingUsp,
	ImageBlock as MarketingImageBlock,
	ContainerImage640x560 as MarketingContainerImage640x560,
	TestimonialCarousel as MarketingTestimonialCarousel,
	Video640x560 as MarketingVideo640x560,
} from '~/components/Marketing';
